import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './PaymentInfoScreen';
import PaymentInfo from './PaymentInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getPayment } from 'src/store/actions/payment-actions';

import { getFormValues } from 'redux-form';
import { QueryParams } from '../../../../../../types/grid';
import { getStudentsSmall } from '../../../../../../store/actions/student-actions';
import { getDistrictsSmall } from '../../../../../../store/actions/district-actions';
import { getVendorsSmall } from '../../../../../../store/actions/vendor-actions';
import { getInvoices, getInvoicesSmall } from '../../../../../../store/actions/invoice-actions';
import { getServiceTypes } from '../../../../../../store/actions/service-type-actions';
import { caseNumbers } from '../../../../../../store/actions/case-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        payment: state.payments.current,
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        providers: selectNameProviders(state),
        vendors: selectNameVendors(state),
        invoices: state.invoices.data,
        inProgress: state.invoices.inProgress,
        serviceTypes: state.serviceTypes.data,
        caseNumbers: state.cases.caseNumbers,
        valuesForm: getFormValues('payment-form')(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getPayment(id)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getCaseNumbers: () => dispatch(caseNumbers()),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getInvoices: (params: QueryParams) => dispatch(getInvoicesSmall({ ...params, notTotal: true })),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}

const PaymentInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PaymentInfo);

export default PaymentInfoScreen;
